// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#fmaily-permitted-function-list[data-v-042f5fb8]{max-width:1300px;margin-left:auto;margin-right:auto}#fmaily-permitted-function-list .box-header .title[data-v-042f5fb8]{font-size:22px;font-weight:700}#fmaily-permitted-function-list .box-header .setting-btn[data-v-042f5fb8]{min-width:150px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
